import React from "react";
import { Typography } from "@mui/material";
import styled from "@emotion/styled";
import LegendSwatch from "@hyro-components/hyro-pie-chart/LegendSwatch";
import TrendIndicator from "src/components/widgets/overview/tiles/TrendIndicator";

const SankeyTooltipContent = ({ color, label, headerValue, value, caption, delta, sections = [] }) => (
  <Content data-testid="sankey-tooltip-content">
    <HeaderRow>
      <HeaderLabelGroup>
        <LegendSwatch color={color} />
        <Typography variant="tooltip" color="text.800" sx={{ whiteSpace: "nowrap" }}>{label}</Typography>
      </HeaderLabelGroup>
      {headerValue && <Typography variant="tooltip" color="text.700" sx={{ whiteSpace: "nowrap" }}>{headerValue}</Typography>}
    </HeaderRow>
    {value && (
      <MetricRow>
        <MetricGroup>
          <Typography variant="h5" color="text.800">{value}</Typography>
          {caption && <Caption variant="tooltip" color="text.700">{caption}</Caption>}
        </MetricGroup>
        {delta && <TrendIndicator {...delta} showPeriod={false} />}
      </MetricRow>
    )}
    {sections.map((section) => (
      <React.Fragment key={section.title}>
        <Divider />
        <Section>
          <Typography variant="tooltip" color="text.600">{section.title}</Typography>
          {section.rows.map((row) => (
            <SectionRow key={row.label}>
              <Typography variant="tooltip" color="text.700">{row.label}</Typography>
              <SectionValueGroup>
                <Typography variant="tooltip" color="text.700">{row.value}</Typography>
                {row.delta && <TrendIndicator {...row.delta} showPeriod={false} />}
              </SectionValueGroup>
            </SectionRow>
          ))}
        </Section>
      </React.Fragment>
    ))}
  </Content>
);

const Content = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  gap: theme.spacing(1),
  minWidth: 220
}));

const HeaderRow = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: theme.spacing(2),
  width: "100%"
}));

const HeaderLabelGroup = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1)
}));

const MetricRow = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "flex-end",
  justifyContent: "space-between",
  gap: theme.spacing(2)
}));

const MetricGroup = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "flex-end",
  gap: theme.spacing(1)
}));

const Caption = styled(Typography)({
  whiteSpace: "nowrap",
  paddingBottom: 3
});

const Divider = styled("div")(({ theme }) => ({
  height: 1,
  width: "100%",
  backgroundColor: theme.palette.system[200]
}));

const Section = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1)
}));

const SectionRow = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: theme.spacing(2)
}));

const SectionValueGroup = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1)
}));

export default SankeyTooltipContent;
